// extracted by mini-css-extract-plugin
export var content = "shenclinic-module--content--0c71a";
export var detailContainer = "shenclinic-module--detailContainer--63483";
export var horizontal = "shenclinic-module--horizontal--b9ba5";
export var imageContainer = "shenclinic-module--imageContainer--88cf5";
export var navContainer = "shenclinic-module--navContainer--4bd85";
export var root = "shenclinic-module--root--dbb79";
export var vertical = "shenclinic-module--vertical--c23cc";